import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteInvoiceData,
  downloadInvoiceExcel,
  editfertilizerData,
  editHerbicideData,
  getBillingEntityForLandlord,
  getEditDataforInvoice,
  getFieldTypesLandlord,
  getInvoicesApi,
  getJDOpsCrop,
  saveCustomBill,
  saveGridData,
} from "../services/serviceagreements.api";
import { Option } from "../screens/ServiceAgreements/types";

interface LandlordBillGeneration {
  invoicesList: BillInvoice[];
  billingEntity: Option[];
  fieldsArray: Option[];
  cropTypes: Option[];
  loading: boolean;
  error: null;
  responsebool: boolean;
  invoiceObject: any;
  landlordFields: Option[];
  landlordBillingEntities: Option[];
}
const initialState: LandlordBillGeneration = {
  invoicesList: [],
  loading: false,
  error: null,
  responsebool: false,
  billingEntity: [],
  fieldsArray: [],
  invoiceObject: {},
  cropTypes: [],
  landlordFields: [],
  landlordBillingEntities: [],
};

export interface BillInvoice {
  id: string;
  calendarYear: number;
  calendarMonth: string;
  landlord: string;
  fieldId: number;
  billingEntity: string;
  crop: string;
  invoiceHtml: string;
  invoiceId: string;
  totalDue: number;
}

export interface InvoiceHeader {
  Id: string;
  Date: string;
  Category: string;
  ProductName: string;
  WorkName: string;
  Acres: number;
  AcresApplied: number;
  Price: number;
  TotalApplied: number;
  AppliedUnit: string;
  PriceUnit: string;
  TotalCost: number;
  LandlordShare: number;
  TotalDue: number;
  ApplicationActivityCost: number;
  ProductCost: number;
  ProductType: string;
}

export const getInvoicesGrid = createAsyncThunk(
  "api/Invoice",
  async (data: any) => {
    const response = await getInvoicesApi(data);
    return response.data;
  }
);

export const getBillingEntity = createAsyncThunk(
  "api/billingEntity",
  async (data: any) => {
    const response = await getBillingEntityForLandlord(data);
    return response.data;
  }
);

export const getLandlordBillingEntities = createAsyncThunk(
  "api/landlordBillingEntity",
  async (data: any) => {
    const response = await getBillingEntityForLandlord(data);
    return response.data;
  }
);

export const getJDOpsCrops = createAsyncThunk("api/jdOps/crops", async () => {
  const response = await getJDOpsCrop();
  return response.data;
});

export const getFieldTypesonLandlord = createAsyncThunk(
  "api/fieldTypes",
  async (data: any) => {
    const response = await getFieldTypesLandlord(data);
    return response.data;
  }
);

export const getLandlordFieldTypes = createAsyncThunk(
  "api/fieldTypesAddbill",
  async (data: any) => {
    const response = await getFieldTypesLandlord(data);
    return response.data;
  }
);

export const getEditInvoiceResponse = createAsyncThunk(
  "api/invoiceTable",
  async (data: any) => {
    const response = await getEditDataforInvoice(data);
    return response.data;
  }
);

export const downloadExcel = createAsyncThunk(
  "api/donwloadexcel",
  async (id: string) => {
    const response = await downloadInvoiceExcel(id);
    if (response.data) {
      const contentDisposition = response.headers["content-disposition"];
      let filename = "downloaded-file.xlsx";

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      const blob = new Blob([response.data]);
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = filename; // Set desired file name
      downloadLink.click();
    }
    return response.data;
  }
);

export const saveInvoiceDetails = createAsyncThunk(
  "api/saveInvoice",
  async (data: any) => {
    const response = await saveGridData(data);
    return response;
  }
);

export const addNewBillApi = createAsyncThunk(
  "addApi/addNewBill",
  async (data: any) => {
    const response = await saveCustomBill(data);
    return response;
  }
);

export const editFertilizerGridData = createAsyncThunk(
  "addFertilizerData",
  async(data: any) => {
    const response = await editfertilizerData(data);
    return response;
  }
)

export const editHerbicideGridData = createAsyncThunk(
  "editherbicideGridData",
  async(data: any) => {
    const response = await editHerbicideData(data);
    return response;
  }
)

export const deleteInvoice = createAsyncThunk(
  "api/deleteInvoice",
  async (id: string) => {
    const response = await deleteInvoiceData(id);
    return response;
  }
);

const landlordBillingInvoiceSlice = createSlice({
  name: "billingInvoiceSlice",
  initialState,
  reducers: {
    resetResponseBool: (state) => {
      state.responsebool = false;
    },
    resetLandlordFieldTypes: (state) => {
      state.landlordFields = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoicesGrid.fulfilled, (state, action) => {
        state.loading = false;
        state.invoicesList = action.payload;
      })
      .addCase(getBillingEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.billingEntity = action.payload;
      })
      .addCase(getLandlordBillingEntities.fulfilled, (state, action) => {
        state.loading = false;
        state.landlordBillingEntities = action.payload;
      })
      .addCase(getFieldTypesonLandlord.fulfilled, (state, action) => {
        state.loading = false;
        state.fieldsArray = action.payload;
      })
      .addCase(getLandlordFieldTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.landlordFields = action.payload;
      })
      .addCase(getEditInvoiceResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.invoiceObject = action.payload;
      })
      .addCase(getJDOpsCrops.fulfilled, (state, action) => {
        state.loading = false;
        state.cropTypes = action.payload;
      });
  },
});

export default landlordBillingInvoiceSlice.reducer;
export const { resetResponseBool, resetLandlordFieldTypes } =
  landlordBillingInvoiceSlice.actions;


